import {View, CloseButton, Heading, Flex} from "@instructure/ui"
const StudentPreviewHeader = () => {
    const t = window._t
    const handleCloseClick = () => window.close();

    return (
        <View as="div" position="sticky" top='0' left='0' width="100%" alignItems="start"
              shadow="resting">
            <Flex height="6rem" justifyItems="space-between" alignItems="center" padding="medium">
                <Flex.Item shouldShrink shouldGrow>
                    <Heading level="h2" as="h1">{t("Student View")}</Heading>
                </Flex.Item>
                <Flex.Item padding="none none none medium">
                    <CloseButton size="medium" screenReaderLabel="Close" onClick={handleCloseClick}/>
                </Flex.Item>
            </Flex>
        </View>
    )
}

export {StudentPreviewHeader}